export default __webpack_public_path__ + "img/Terrain-Maps-New-Mexico.jpg";